import { render, staticRenderFns } from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=template&id=e15dcf96&scoped=true"
import script from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=script&lang=js"
export * from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=script&lang=js"
import style0 from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=style&index=0&id=e15dcf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15dcf96",
  null
  
)

export default component.exports